export function multilingualStringPreview(multilingualString: any) {
  const langs = (multilingualString || {}).langs
  if (Array.isArray(langs)) {
    return langs?.find((x: any) => x?.language == 'en')?.value
  } else {
    //is an object. Due to custom preview filter that target (for instance) name.langs.0.value, the langs can be an hash
    return langs?.[0]?.value
  }
}
